<template>
  <div id="app" :class="getTheme['theme-name']">
    <can I="am" a="customer">
      <days-left />
    </can>
    <main id="panel">
      <div v-show="!$can('all', 'anon') && isDefaultLayout">
        <sidebar></sidebar>
      </div>

      <div class="content-area">
        <!-- <vk-offcanvas> -->
        <main-header v-show="!$can('all', 'anon') && isDefaultLayout">
          <template slot="menupin">
            <div style="padding: 15px">
              <span
                v-show="!$can('all', 'anon')"
                id="hamburger"
                @click="toggleSidebar(!isSidebarCollapsed)"
                class="fa fa-bars toggle-button"
              ></span>
            </div>
          </template>
        </main-header>
        <!-- <UsersWithoutDevice /> -->
        <div
          :class="`${
            isDefaultLayout ? 'page-content__header-description' : ''
          }`"
          :style="`${
            isDefaultLayout
              ? 'margin-bottom: 0px; padding-left: 24px; margin-top: 0px;'
              : ''
          }`"
        >
          <router-link
            v-show="goback"
            v-if="
              $routerHistory.hasPrevious() &&
              !$can('all', 'anon') &&
              isDefaultLayout
            "
            :to="{ path: $routerHistory.previous().path }"
            class="back-nav-pin"
          >
            <span class="fa fa-arrow-left"></span>
          </router-link>
        </div>

        <router-view style="flex: 1"></router-view>
        <!-- </vk-offcanvas-content> -->
      </div>
    </main>
    <!-- <main v-else id="">
      <div class="content-area">
        <vk-offcanvas-content>
          <div class="">
            <router-view style="flex: 1;"></router-view>
          </div>
        </vk-offcanvas-content>
      </div>
    </main> -->
  </div>
</template>

<script>
import Slideout from "vue-slideout";

/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import { OffcanvasContent } from "vuikit/lib/offcanvas";
import MainFooter from "./components/MainFooter";
import MainHeader from "./components/MainHeader";
import DaysLeft from "./components/pages/kitchen/Notifications/DaysLeft.vue";
import NotifyBox from "./components/pages/kitchen/Notifications/NotifyBox.vue";
import UsersWithoutDevice from "./components/pages/kitchen/UsersWithoutDevice.vue";
import Sidebar from "./components/Sidebar";

export default {
  name: "app",
  components: {
    Sidebar,
    MainFooter,
    MainHeader,
    "vk-offcanvas-content": OffcanvasContent,
    "days-left": DaysLeft,
    NotifyBox,
    UsersWithoutDevice,
  },
  data() {
    return {
      sideBarCollapse: true,
      goback: true,
      isDefaultLayout: true,
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getDevices",
      "getUserSession",
      "isHome",
      "getDrawerMode",
      "getTheme",
      "getDeviceByUserId",
      "getAssignedDevices",
      "isSidebarCollapsed",
      "getUserNotifications",
    ]),
  },
  methods: {
    ...mapActions([
      "setAccess",
      "setUserSession",
      "setDrawerMode",
      "setTheme",
      "toggleSidebar",
      "saveUserNotifications",
    ]),
    // fetchUsers() {
    //   const HTTP = this.$httpUtils.instance;
    //   // console.log(JSON.stringify(this.getUserSession))
    //   const url = "/users";
    //   HTTP.get(url)
    //     .then(response => {
    //       const usersList = response.data;
    //       // this.$store.commit("saveUsers", usersList);
    //       // console.log(this.getUserById(1))
    //     })
    //     .catch(error => {
    //       console.log("error", error);
    //     });
    // },
    fetchDevices() {
      const HTTP = this.$httpUtils.instance;
      const url = "/devices";
      HTTP.get(url)
        .then((response) => {
          const usersList = response.data;
          this.$store.commit("saveDevices", usersList);
          // console.log(this.getDevices)
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    handleSlideStart() {
      // console.info("slide-start");
    },
    handleSlideMove(position) {
      // console.info("slide-move", position);
    },
    handleSlideEnd(visible) {
      console.info("slide-end", visible);
      if (visible) {
        document.getElementsByClassName("content-wrap")[0].style.overflow =
          "hidden !important;";

        // console.log(wrapper);
      }
    },
    handleMaskClick() {
      // console.info("mask-click");
      // this.setDrawerMode(false);
      // this.$refs.drawerLayout.toggle(false);
    },
    async getUserAssignedDevices() {
      if (!this.getUserSession) return;
      let userId = this.getUserSession.id;
      let url = `/installations?filter={"where":{"and": [{"userId":${userId}}, {"or":[{ "status": "requested"},{ "status": "commissioned"},{ "status": "completed"}]}]}}`;
      const result = await this.$httpUtils.instance.get(url);
      const res = result && result.data.map((item) => item.CID);
      this.$store.state.loggedinUserInstallationCount =
        result && result.data.length;
      this.$store.commit("setAssignedDevices", res);
    },
    async fetchUserNotifications() {
      const HTTP = this.$httpUtils.NotificationHTTP;
      let devices = this.getAssignedDevices;
      if (!devices || devices.length < 1) return;
      devices = devices.join(",");
      HTTP.get(`notification/${devices}`)
        .then((res) => {
          this.$store.commit("saveUserNotifications", res.data.response.items);
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    setLayout() {
      const exemptedRoutes = [
        "OutrightSale",
        "OSAgreement",
        "OSSummary",
        "OSFinish",
        "Onboarding",
        "LeaseToOwn",
        "LOSummary",
        "JobInformation",
        "KYCUpload",
        "OnboardPaymentDeposit",
        "LOAgreement",
        "BankStatement",
        "CreditCheck",
        "FinishTab",
        "KYC",
        "PayDeposit",
        "LOFinish",
        "OnboardIPP",
        "BVNCheck",
        "OnboardIPPPaymentSummary",
        "AwaitingContract",
        "OnboardContractUpload",
        "OnboardStandard",
        "OnboardStandardLO",
        "OnboardLOPaymentSummary",
        "OnboardStandardOS",
        "OnboardOSPaymentSummary",
        "OnboardIPPWaitlist",
        "ExistingUser",
      ];
      const value = exemptedRoutes.find((x) => x == this.$route.name);
      if (value) {
        this.isDefaultLayout = false;
      }
      // const value = exemptedRoutes.find(route => {
      //   return;
      // });

      // if (!this.$route.name.startsWith("/onboarding/")) {
      //   this.isDefaultLayout = false;
      // }
    },
  },
  mounted() {
    let page = localStorage["PATHMONITOR"] || "/";
    let path_params = JSON.parse(localStorage["PATHPARAMS"] || "{}") || "/";
    this.setTheme();
    this.getUserAssignedDevices();
    this.fetchUserNotifications();
    this.setLayout();
  },
  beforeUpdate() {
    try {
      let lastHistory = this.$routerHistory.previous().path || "";
      if (
        lastHistory.includes("login") ||
        lastHistory.includes("register") ||
        lastHistory == "dashboard"
      )
        this.goback = false;
    } catch (error) {}
  },
};
</script>

<style lang="scss">
// $bootstrap-sass-asset-helper: true;
@import "./assets/scss/style.scss";
@import url(~@/assets/fonts/iconfont/iconfont.css);
// @import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
@import url(~@/assets/fonts/open-sans/style.scss);

select.form-control:not([size]):not([multiple]) {
  height: calc(2.25rem + 13.5px);
}

#panel {
  display: flex;
  flex-flow: row;
  justify-content: center;
  height: 100%;
  position: relative;
}

.content-area {
  position: relative;
}

nav#menu {
  overflow: hidden;
}

.page-content {
  margin-left: 0rem;
  padding-top: 60px;
}

.form-control:read-only {
  background: none;
}

span#hamburger {
  font-size: 20px;
  // margin-left: 15px;
  cursor: pointer;
  display: block;
  color: #c2cfe0;
}

.slideout-menu {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 256px;
  height: 100vh;
  overflow-y: none;
  -webkit-overflow-scrolling: touch;
  z-index: 0;
  display: none;
  background-color: #ecf2f6;
  color: white;
}

.slideout-menu-left {
  left: 0;
}

.slideout-menu-right {
  right: 0;
}

.slideout-panel {
  background-color: #ecf2f6;
  position: relative;
  z-index: 1;
  will-change: transform;
  min-height: 100vh;
}

.slideout-open,
.slideout-open body,
.slideout-open .slideout-panel {
  overflow: hidden;
}

.slideout-open .slideout-menu {
  display: block;
}

.widget {
  margin-bottom: 10px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  border-radius: 4px !important;
  background-color: #ffffff;
  cursor: pointer !important;

  .widget_header {
    display: flex;
    justify-content: space-between;
    .widget_header__title {
      flex: 1;
      font-size: 15px;
      font-weight: 500;
      justify-content: center;
    }
  }

  &:hover {
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.15);
  }

  .widget-icon + .widget-alpha__description,
  .widget-icon + .widget-alpha__amount {
    color: #4d4b4b;
  }

  .top-widget-box {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding: 20px;
    &.performance {
      flex-flow: row-reverse;

      .top-widget-box__body {
        h1 {
          font-size: 24px;
        }
      }
    }

    .top-widget-box__header {
      flex-flow: row;
      display: flex;
      justify-content: space-between;
      color: #6a707e;
      font-size: 15px;

      .icon {
        color: #ffb946;
      }
    }

    .top-widget-box__body {
      flex: 1;
      justify-content: flex-start;
      align-items: flex-start;

      h1,
      p {
        margin: 0px;
      }

      h1 {
        font-size: 36px;
        font-weight: 600;
        letter-spacing: 0.36px;
      }
    }
  }
}

.widget-icon {
  .widget-alpha__icon,
  .widget-alpha__description {
    color: #707070;
    margin-bottom: 12px;
  }
}

.widget .btn {
  justify-content: center !important;
}

.widget_box {
  font-family: "Poppins", Arial, sans-serif;
  position: relative;
  overflow: hidden;
  margin: 10px auto;
  width: 100%;
  background-color: #ffffff;
  border-radius: 5px;
  border-top: 5px solid #269af1;
  color: #9e9e9e;
  text-align: center;
  font-size: 16px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
  min-height: 177px;
}

.widget_box *,
.widget_box *:before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: all 0.1s ease-out;
  transition: all 0.1s ease-out;
}

.widget_box figcaption {
  padding: 8%;
}

.widget_box i {
  font-size: 12px;
  color: #269af1;
  border-radius: 50%;
  padding: 0;
  margin: 0 0 7px;
  text-align: center;
  display: inline-block;
}

.widget_box h3 {
  color: #3c3c3c;
  font-size: 20px;
  font-weight: 300;
  line-height: 24px;
  margin: 10px 0;
}

.widget_box p {
  font-size: 0.9em;
  font-weight: 300;
  margin: 0 0 20px;
}

.widget_box .button {
  text-decoration: none;
  color: #777;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  padding: 5px 10px;
  display: inline-block;
  position: relative;
  z-index: 1;
}

.widget_box.pink {
  border-color: #26f1c5;
}

.widget_box .button:before {
  background-color: #269af1;
  position: absolute;
  top: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  content: "";
  z-index: -1;
  opacity: 0;
}

.widget_box .button:hover {
  color: #fff;
}

.widget_box .button:hover:before {
  top: 0;
  opacity: 1;
}

.global-search-input {
  border: 1px solid #efefef !important;
}

.plan-features {
  padding: 0 0 20px;
  margin: 0;
  list-style: outside none none;
  font-size: 0.9em;
  text-align: right;
}

.plan-features li {
  padding: 8px 20px;
}

.plan-features i,
.plan-features b {
  float: left;
}

.plan-features i {
  margin-right: 8px;
  color: rgba(0, 0, 0, 0.2);
}

@media only screen and (max-width: 768px) {
  .widget-alpha {
    flex-flow: column;
  }
}

.page-content__header-description {
  color: #939daa;
  font-size: 19px;
  line-height: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
}

* {
  font-family: "Poppins", Arial, sans-serif;
}

#__BVID__36___BV_label_ {
  color: #424242 !important;
  border: none !important;
  font-weight: 700 !important;
}

select option {
  text-transform: capitalize !important;
}

.dash-widget {
  padding: 0px;
  flex-flow: column wrap;
}

.dash-widget-header {
  background: #337ab7;
  color: #fff;
  padding: 10px;
  text-align: center;
  font-size: 2rem;
  flex: 1;
  width: 100%;
}

.dash-widget-body {
  display: flex;
  flex-flow: column wrap;
  text-align: center;
  flex: 1;
  width: 100%;
  padding: 10px;
  justify-content: center;
  min-height: 220px;
}

.content-wrap {
  overflow-y: auto !important;
}

/* .page-content {
  padding: 20px;
  // padding-top: 61px !important;
} */

.drawer-wrap {
  z-index: 9999 !important;
}
.vgt-left-align,
.vgt-right-align {
  text-align: left !important;
}

.vgt-left-align:first-child {
  color: #323c47;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.15px;
}
@media (max-width: 400px) {
  .vgt-left-align,
  .vgt-right-align {
    text-align: center !important;
  }
  .page-content {
    padding: 5px !important;
    // padding-top: 61px !important;
  }
}
.back-nav-pin {
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #424242;
  color: #efefef;
  font-size: 20px;
  border-radius: 50%;
}
.back-nav-pin:hover {
  color: #dedede !important;
  transform: scale(1.1) !important;
}
sup {
  z-index: 1000;
}
// 1399
</style>



// WEBPACK FOOTER //
// src/App.vue